export const removeUndefinedValuesFromObject = <T extends {}>(obj: T): T => {
    Object.keys(obj).forEach(
        key => obj[key as keyof T] === undefined && delete obj[key as keyof T]
    );
    return obj;
};
